import { createSlice } from "@reduxjs/toolkit";

interface ReportsState {
  submitting: boolean;
  submitted: boolean;
  error: string | null;
}

const initialState: ReportsState = {
  submitting: false,
  submitted: false,
  error: null,
};

const reportsSlice = createSlice({
  name: "reports",
  initialState,
  reducers: {
    submitStart(state) {
      state.submitting = true;
      state.submitted = false;
      state.error = null;
    },
    submitSuccess(state) {
      state.submitting = false;
      state.submitted = true;
      state.error = null;
    },
    submitFailure(state, action) {
      state.submitting = false;
      state.submitted = false;
      state.error = action.payload;
    },
    resetSubmission(state) {
      state.submitting = false;
      state.submitted = false;
      state.error = null;
    },
  },
});

export const { submitStart, submitSuccess, submitFailure, resetSubmission } =
  reportsSlice.actions;
export default reportsSlice.reducer;
